import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Contrato } from '../model/contrato.model';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContratosService {

  constructor(private http: HttpClient) { }
 
  baseUrl = environment.baseUrl;

  getAll(id: string, ordenacaoData?: number ): Observable<any>{
    const url = `${this.baseUrl}contratos/cliente/${id}`;
    return this.http.get<any>(url)
  }

  cadastrarService(contrato: Contrato): Observable<Contrato>{
    const url = `${this.baseUrl}contratos/cadastro`;
    return this.http.post<Contrato>(url, contrato);
  }

  listarIdService(id: any): Observable<Contrato>{
    const url = `${this.baseUrl}contratos/${id}`
    return this.http.get<Contrato>(url);
  }

  atualizarService(contrato: Contrato): Observable<Contrato>{
    const url = `${this.baseUrl}contratos/atualizar/${contrato.sr_id}`;
    return this.http.put<Contrato>(url, contrato);
  }

  contratosExpirar(id: any): Observable<any>{
    const url = `${this.baseUrl}contratos/expiracao/${id}`;
    return this.http.get<any>(url)
  }

  marcarVisualizacao(contrato:any): Observable<Contrato>{
    const url = `${this.baseUrl}contratos/marcarVisualizacao`;
    return this.http.post<Contrato>(url, contrato);
  }

  cancelaOuRenova(dado:any): Observable<any>{
    const url = `${this.baseUrl}contratos/renovar/cancelar`;
    return this.http.put<any>(url, dado);
  }

  produtosVerificacao(): Observable<any>{
    const url = `${this.baseUrl}contratos`;
    return this.http.get<any>(url);
  }
}
